export const QA_NAME_APPLICANT_PROFILE_WIDGET_MATCHED_LISTING =
  'applicantProfileWidgetMatchedListing'

export const QA_NAME_APPLICANT_PROFILE_MATCHED_LISTING_OPEN =
  'applicantProfileMatchedListingOpen'
